import { CreateOrEditGitTrigger } from "./CreateOrEditGitTrigger";
export function CreateReleaseCreationGitTriggerPage() {
    return <CreateOrEditGitTrigger triggerId={undefined}/>;
}
